import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

const ReapprovalDialog = ({ open, onKeepEditing, onConfirm, isSaving }) => (
  <Dialog open={open} onClose={onKeepEditing} maxWidth='xs' fullWidth>
    <DialogTitle sx={{ fontWeight: 700, pr: 6 }}>Re-approval required</DialogTitle>
    <DialogContent>
      <Typography variant='body2' color='text.secondary'>
        If you save these changes, this prospect will move back to Pending and must be approved again before you can
        engage with this prospect.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5 }}>
      <Button onClick={onKeepEditing} disabled={isSaving} sx={{ textTransform: 'none' }}>
        Keep editing
      </Button>
      <Button variant='contained' onClick={onConfirm} disabled={isSaving} sx={{ textTransform: 'none' }}>
        Save & request approval
      </Button>
    </DialogActions>
  </Dialog>
);

export default ReapprovalDialog;
